export default __webpack_public_path__ + "webassets/cookies-plate.aeff1a13.png";